// @noflow
const LOAN_PURPOSE = {
  SELECT_PURPOSE : 'purpose',
  AUTO_PURCHASE : 'auto-purchase',
  CARAVAN_BOAT_RECREATIONAL : 'caravan-boat-recreational',
  EDUCATION : 'education',
  HOUSEHOLD_FURNISHINGS : 'household-furnishings',
  AUTO_REPAIRS : 'auto-repairs',
  CONSOLIDATION : 'consolidation',
  HOME_IMPROVEMENTS : 'home-improvements',
  MEDICAL_DENTAL : 'medical-dental',
  TRAVEL_HOLIDAY : 'travel-holiday',
  OTHER : 'other'
}

export const PURPOSE_NZ_OPTIONS = [
  { value: LOAN_PURPOSE.SELECT_PURPOSE, text: 'Select...' },
  { value: LOAN_PURPOSE.AUTO_PURCHASE, text: 'Auto Purchase' },
  { value: LOAN_PURPOSE.AUTO_REPAIRS, text: 'Auto Repairs' },
  {
    value: LOAN_PURPOSE.CARAVAN_BOAT_RECREATIONAL,
    text: 'Caravan/Boat/Recreational'
  },
  { value: LOAN_PURPOSE.CONSOLIDATION, text: 'Consolidation' },
  { value: LOAN_PURPOSE.EDUCATION, text: 'Education' },
  { value: LOAN_PURPOSE.HOME_IMPROVEMENTS, text: 'Home improvements' },
  {
    value: LOAN_PURPOSE.HOUSEHOLD_FURNISHINGS,
    text: 'Household furnishings'
  },
  { value: LOAN_PURPOSE.MEDICAL_DENTAL, text: 'Medical & Dental' },
  {
    value: LOAN_PURPOSE.TRAVEL_HOLIDAY,
    text: 'Travel/Holiday'
  },
  { value: LOAN_PURPOSE.OTHER, text: 'Other' }
];

export const REPAYMENT_PERIOD_NZ_OPTIONS = [
  { value: 0.5, text: '6 months' },
  { value: 1, text: '1 year' },
  { value: 1.5, text: '1.5 years' },
  { value: 2, text: '2 years' },
  { value: 2.5, text: '2.5 years' },
  { value: 3, text: '3 years' },
  { value: 3.5, text: '3.5 years' },
  { value: 4, text: '4 years' },
  { value: 4.5, text: '4.5 years' },
  { value: 5, text: '5 years' },
  { value: 5.5, text: '5.5 years' },
  { value: 6, text: '6 years' },
  { value: 6.5, text: '6.5 years' },
  { value: 7, text: '7 years' }
];
